import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOnHandEntry } from "../models/onHandDelivery";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const GetOnHandDetailsAPI = async (osdNumber: number | string): Promise<IOnHandEntry> => {
  try {
    const response = await axios.get(`${getUrl(ApiType.ON_HAND_VIEW)}/${osdNumber}`);
    return response?.data ?? {};
  } catch (error) {
    return throwApiError(error, ErrorMessages.aSEntryDetailsAPIError, { badRequestOrder: "errorsFirst" });
  }
};
